import React, { Component } from 'react';
import { withFormik } from 'formik';
import { defaultTo, filter, union } from 'ramda';
import cn from 'classnames';

import styles from './styles.m.scss';

import { apiUpdateRegistration } from '../../../../../api/registration';
import { handleError, handleSuccess } from '../../../../../util/forms';

import Footer from '../../../../../components/Accordion/Footer';
import FancyRadio from '../../../../../components/Forms/FancyRadio';
import AddressModal from '../../../../../components/Modal/AddressModal';
import * as yup from 'yup';

class Shipping extends Component {
  state = {
    showModal: false,
  };

  render() {
    const {
      values,
      handleBlur,
      handleChange,
      handleSubmit,
      isSubmitting,
      isValid,
      setFieldValue,
      setStep,
      step,
      user,
      registration,
    } = this.props;
    const { showModal } = this.state;
    const addresses = filter((address) => address, union([registration.shipping], user.addresses));

    return (
      <form>
        <div className="d-flex mb-3">
          <h2 className={cn(styles.stepHeader, 'flex-fill')}>Please select your shipping address</h2>
          <button
            type="button"
            className="btn btn-primary align-self-center"
            onClick={() => this.setState({ showModal: true })}
          >
            Add New Address
          </button>
        </div>
        {addresses.map((address) => (
          <FancyRadio
            key={address.id}
            name="shippingAddressId"
            label={address.name}
            className="col-md-12"
            value={address.id}
            checked={values.shippingAddressId}
            onBlur={handleBlur}
            onChange={handleChange}
          >
            <div>
              {address.addressLine1}
              <br />
              {address.addressLine2}
              {address.addressLine2 && <br />}
              {address.city}, {address.state} {address.zip} {address.country}
            </div>
          </FancyRadio>
        ))}
        <Footer
          step={step}
          setStep={setStep}
          isValid={isValid}
          isSubmitting={isSubmitting}
          handleSubmit={handleSubmit}
        />
        <AddressModal
          show={showModal}
          onHide={(id) => {
            if (id) {
              setFieldValue('shippingAddressId', id);
            }
            this.setState({ showModal: false });
          }}
          user={user}
        />
      </form>
    );
  }
}

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;

    apiUpdateRegistration(props.registration.id, { stepName: props.name, ...payload })
      .then(({ data }) =>
        props.updateRegistration({ ...data, internationalFees: defaultTo([], data.internationalFees) }),
      )
      .then(() => handleSuccess(formProps))
      .then(() => props.setStep(props.step + 1))
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: ({ registration }) => ({
    shippingAddressId: defaultTo('', registration.shippingAddressId),
  }),
  validationSchema: () =>
    yup.object().shape({
      shippingAddressId: yup.number().required('You must have a shipping address'),
    }),
  isInitialValid: ({ initialValues, validationSchema }) => validationSchema().isValidSync(initialValues),
  validateOnChange: true,
})(Shipping);
